import {takeLatestF, putAll} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {GetAvailableAnimalsAction, animalBrowserAction} from '../action';

function* execute({payload: {animalType, text}}: GetAvailableAnimalsAction): SagaIterator {
    const response = yield* call(Api.cabGetAvailableAnimals, {text}, {animalType});

    if (response.isSuccess) {
        yield* put(animalBrowserAction.getAvailableAnimalsSuccess(response.data));
    } else {
        yield putAll(showBeError(response, t('animalBrowser')('addAnimals')));
    }
    yield* put(animalBrowserAction.setLoading('availableAnimalsLoading', false));
}

/**
 * Loads animals available to add from an existing list or database search.
 *
 * @returns The saga watcher for `GET_AVAILABLE_ANIMALS`.
 */
export function* getAvailableAnimalsSaga(): SagaIterator {
    yield takeLatestF('animalBrowser/GET_AVAILABLE_ANIMALS', execute);
}
